import type { ConfigRefreshTarget } from '@/store/global'

const CONFIG_MUTATION_TOOL_MAP: Record<string, ConfigRefreshTarget[]> = {
  msq_add_provider: ['providers', 'models'],
  msq_delete_provider: ['providers', 'models'],
  msq_add_model: ['models', 'agents'],
  msq_delete_model: ['models', 'agents'],
  msq_add_agent: ['agents'],
  msq_update_agent: ['agents'],
  msq_delete_agent: ['agents'],
  msq_create_workflow: ['workflows'],
  msq_update_workflow: ['workflows'],
  msq_delete_workflow: ['workflows']
}

export function getRefreshTargetsForToolName(toolName?: string | null): ConfigRefreshTarget[] {
  if (!toolName) return []
  return CONFIG_MUTATION_TOOL_MAP[toolName] ?? []
}
